module.exports = __webpack_public_path__ + "media/images/result_sets/circles/2n3r4r8n-154e10a854d2c215a9eae2852466007a.svg";